<template>
  <div class="DowloadTemplateBox" v-if="DowloadTemplateList.length != 0">
    <div class="DowloadTemplateTitle">
      下载模板
    </div>
    <div class="Template">
      <div class="TemplateBox" v-for="(item , index) of DowloadTemplateList" :key="index" @click="dowlaodClick(item)">
        {{item.Text}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    DowloadTemplateList: {
      type: Array
    }
  },
  data() {
    return {

    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {
    dowlaodClick(item) {
      if (item.Extension == 'pdf') {
        window.open(item.Value, '_blank')
      } else {
        window.location.href = item.Value
      }
    }
  },
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
.DowloadTemplateBox {
  height: 100px;
  width: 100%;
  border-bottom: 1px solid rgb(234 236 239);
  position: relative;
  top: 10px;

  .DowloadTemplateTitle {
    font-size: 16px;
    font-weight: 500;
    color: #16181a;
    position: relative;
    top: 10px;
  }
 
  .TemplateBox {
    border-bottom: 2px solid #00266d;
    height: 30px;
    font-size: 16px;
    font-weight: 500;
    color: #00266d;
    cursor: pointer;
  }
  .Template {
    display: flex;
    width: auto;
    justify-content: space-between;
    // justify-content: space-around;
    position: relative;
    top: 30px;
    gap: 30px;
  }
  .Template::after {
    content: "";
    flex: auto;

  }
}
</style>